module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Social_Comments_Form":{"handleDom.keyup.target":[{"value":"textarea","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107003},"path":"~.Social_Comments_Form","_fox_":1}],"handleDom.keyup.event":[{"value":"keyup","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107004},"path":"~.Social_Comments_Form","_fox_":1}],"handleDom.keyup.callback":[{"value":function (el, alias, scope, e) {
var _paddingTop = 9;
var _paddingBottom = 4;
if ((e.ctrlKey === true && e.keyCode === 86) || [13, 46, 8].indexOf(e.keyCode) !== -1) {
setTimeout(function () {
el.style.height = [18 * el.value.split('\n').length + _paddingTop + _paddingBottom, 'px'].join('');
}, 10);
}
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107013},"path":"~.Social_Comments_Form","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./options/comments.js
// module id = 997
// module chunks = 4